// Styles
import { headerHeight } from '../../scripts/helpers';
import './page-legal.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPageLegal = (context) => {
  const pageLegalSection = context.closest('.shopify-section');
  if (!pageLegalSection) return;

  const mobileMenuContainer = pageLegalSection.querySelector('.legal-area__menu');
  const desktopMenuContainer = pageLegalSection.querySelector('.legal-area__menu__desktop');
  if (!mobileMenuContainer || !desktopMenuContainer) return;

  mobileMenuContainer.style.top = headerHeight();
  desktopMenuContainer.style.top = headerHeight();

  ['resize', 'orientationchange'].forEach(evt => {
    window.addEventListener(evt, function () {
      mobileMenuContainer.style.top = headerHeight();
      desktopMenuContainer.style.top = headerHeight();
    });
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.legal-area__content'), (el) => {
    window.dAgency.initPageLegal(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.legal-area__content'), (el) => {
      window.dAgency.initPageLegal(el);
    });
  });
}
